import React, { useCallback, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { PromiseType } from 'utility-types';
import { getApolloErrorMessageCodes } from '../../lib/errors';
import { completeLogin } from './completeLogin';
import Login, { FormProps } from './Login';
import { login } from './mutations';
import TwoFactorChallenge from './TwoFactorChallenge';
import { TWO_FACTOR_LOGIN_PATH, TWO_FACTOR_REQUIRED } from './twoFactorMutations';

export default function LoginContainer(): React.ReactElement {
  const history = useHistory();
  const { search } = useLocation();
  const isTwoFactorStep = Boolean(useRouteMatch(TWO_FACTOR_LOGIN_PATH));
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = useCallback(
    async ({ email, password, captchaResponse }: FormProps) => {
      setIsSubmitting(true);

      let response: PromiseType<ReturnType<typeof login>>;
      try {
        response = await login({ email, password, captchaResponse });
      } catch (e) {
        if (getApolloErrorMessageCodes(e)?.includes(TWO_FACTOR_REQUIRED)) {
          // keeps the search, so that ?redirect= still applies after the second step
          history.push({ pathname: TWO_FACTOR_LOGIN_PATH, search });
          return;
        }
        throw e;
      } finally {
        setIsSubmitting(false);
      }

      const { user, userHash } = response;
      completeLogin({ id: user.id, email, userHash });
    },
    [history, search],
  );

  if (isTwoFactorStep) return <TwoFactorChallenge />;

  return <Login {...{ isSubmitting, onSubmit }} />;
}
